export const LAODING = 'LOADING';
export const GUEST_PAGE_PERMISION = 'GUEST_PAGE_PERMISION';
export const GET_GUEST_PAGE_PERMISION = 'GET_GUEST_PAGE_PERMISION';
export const ERROR_PERMISSION = 'ERROR_PERMISSION';
export const GET_TABLE_CHANGE_PERMISSION_SUCCEES = 'GET_TABLE_CHANGE_PERMISSION_SUCCEES';
export const TABLE_CHANGE_PERMISSION_SUCCESS = 'TABLE_CHANGE_PERMISSION_SUCCESS';
